import { Dayjs } from 'dayjs';

export const stringCompare = (a: string, b: string): number => (a ?? '').localeCompare(b ?? '');

export const dayjsCompare = (a: Dayjs, b: Dayjs): number => {
    if (!a && !b) {
        return 0;
    }

    if (!a) {
        return -1;
    }

    if (!b) {
        return 1;
    }

    if (a.isSame(b)) {
        return 0;
    }

    return a.isAfter(b) ? 1 : -1;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const anyCompare = (a: any, b: any): number => {
    if (a === b) {
        return 0;
    }

    return a < b ? -1 : 1;
};
